export default {
  login: {
    title: 'Se connecter à mypage (ma page)',
    double_check_text: 'Échec de la connexion. Veuillez saisir les données correctes.',
    id_email: 'ID/Adresse e-mail',
    password: 'Mot de passe',
    password_display: 'Afficher le mot de passe',
    password_no_display: 'Cacher le mot de passe',
    login: 'Connexion',
    keep_login_text: 'Garder le statut de connexion',
    forgot_password_text: 'Mot de passe oublié',
    contact_us: "S'inscrire ici",
    asuene_service_outline: 'Service cloud de visualisation du CO2 « ASUENE »',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'Plateforme de recrutement axée sur les talents de GX/ESG « ASUENE CAREER »',
    corporate_page: "Site Web de l'entreprise",
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
